export function decodeBase64<T>(token: string): T | null {
  try {
    return JSON.parse(atob(token));
  } catch (e) {
    return null;
  }
}
